import axios from 'axios';

import { TravelRequest } from '@/module/Travel/Request/model/TravelRequestTypes';

import { Id, getData } from '@feature/utils';

import {
  TravelApprovalParams,
  TravelApprovalQueue,
  TravelDeanMailRouting,
  TravelDeanMailRoutingRequest,
  TravelDecisionRequest,
  TravelReturnRequest,
} from './TravelApprovalTypes';

export function getPaged(params: TravelApprovalParams) {
  return axios
    .get<TravelApprovalQueue>('/travel/approvals/paged', {
      params,
    })
    .then(getData);
}

export function approve(requestId: Id) {
  return axios.post<TravelRequest>(`/travel/approvals/${requestId}/approve`).then(getData);
}

export function markBoardSent(requestId: Id) {
  return axios.post<TravelRequest>(`/travel/approvals/${requestId}/board-sent`).then(getData);
}

export function returnForChanges(requestId: Id, request: TravelReturnRequest) {
  return axios.post<TravelRequest>(`/travel/approvals/${requestId}/return`, request).then(getData);
}

export function reject(requestId: Id, request: TravelDecisionRequest) {
  return axios.post<TravelRequest>(`/travel/approvals/${requestId}/reject`, request).then(getData);
}

export function getDeanMailRouting() {
  return axios.get<TravelDeanMailRouting>('/travel/dean-mail-routing').then(getData);
}

export function saveDeanMailRouting(request: TravelDeanMailRoutingRequest) {
  return axios.put<TravelDeanMailRouting>('/travel/dean-mail-routing', request).then(getData);
}
